import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import ReactStars from "react-rating-stars-component"
import ModalCard from '../../ProductCardAll/ModalCard/ModalCard'

import formatCurrency from '../../Util/Util';
import { DataContext } from '../../Context/Context'
import "./ProductCard0.css"



function ProductCard0({ product, classes ,withDetailsModal }) {
    const value = useContext(DataContext);
    const addCart = value.addCart;
    return (
        <>
            {/* <div className="products-wrapper"> */}
            {/* <div className="col-12 col-sm-6 col-md-4 col-xl-3 "> */}
            <div className={classes && classes} >
                <div className="card card-product shadow bdrs-color ">
                    <Link to={`/products/${product._id}`} className="card-image d-flex">
                        <img src={product.images[0]} className='img img-fluid' alt="product-img" />
                    </Link>
                    <div className="table">
                        <h5 className='card-caption text-center py-2'>
                            {product.name}
                        </h5>
                        {withDetailsModal && <ModalCard {...product} />}
                            
                        <div className="card-description text-center ">
                            {product.fullName}
                        </div>
                        <div className="d-flex justify-content-center">
                            <ReactStars
                                count={5}
                                size={24}
                                value={3}
                                activeColor="#ffd700" />
                        </div>
                        <div className="ftr bg-white">
                            <div className="price">
                                <h6>{formatCurrency(product.price)} </h6>
                            </div>
                            <div className="stats">
                                <button type="button" rel="tooltip" className="btn btn-just-icon btn-simple btn-warning p-0 border-0" onClick={() => addCart(product._id)}>
                                    <span className="bi bi-cart-fill"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </div> */}
            {/* </div> */}
        </>
    )
}

export default ProductCard0